import { render, staticRenderFns } from "./PaglieraniWidgetHistory.vue?vue&type=template&id=d1c25b44&scoped=true&"
import script from "./PaglieraniWidgetHistory.vue?vue&type=script&lang=js&"
export * from "./PaglieraniWidgetHistory.vue?vue&type=script&lang=js&"
import style0 from "./PaglieraniWidgetHistory.vue?vue&type=style&index=0&id=d1c25b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c25b44",
  null
  
)

export default component.exports